import Dots from 'components/Dots';
import Footer from 'components/Footer';
import ImagePopup from 'components/ImagePopup';
import MainImage from 'components/MainImage';
import PartnerNew from 'components/PartnerNew';
// import ProductMenu from 'components/ProductMenu';
import ProductMenuNew from 'components/ProductMenuNew';
// import Slideritem from 'components/SliderItmes';
import URL from 'constants/url';

import { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import '../../css/popups.css';

function Main2() {
  const DIVIDER_HEIGHT = 0;
  const outerDivRef = useRef();
  const FOOTER_HEIGHT = 348;
  const [currentPage, setCurrentPage] = useState(1);
  let startY; // 터치 시작 위치
  const [isScrolling, setIsScrolling] = useState(false); // 스크롤 여부 상태

  // 페이지 높이를 미리 계산
  const pageHeight = window.innerHeight;
  
  const scrollToPage = (page) => {
    outerDivRef.current.scrollTo({
      top: page * (pageHeight + DIVIDER_HEIGHT),
      left: 0,
      behavior: "smooth",
    });
    setCurrentPage(page + 1); // 페이지는 0부터 시작하므로 +1
  };

  const handleWheel = (e) => {
    e.preventDefault();
    if (isScrolling) return; // 이미 스크롤 중이면 리턴
    setIsScrolling(true); // 스크롤 시작

    const deltaY = e.deltaY;

    if (deltaY > 0) {
      if (currentPage < 6) { // 6페이지까지 존재한다고 가정
        scrollToPage(currentPage);
      }
    } else {
      if (currentPage > 1) {
        scrollToPage(currentPage - 2); // 이전 페이지로
      }
    }
    // 1초 후에 스크롤 상태 리셋
    setTimeout(() => {
      setIsScrolling(false);
    }, 1000); // 1000ms = 1초
  };

  const handleTouchStart = (e) => {
    startY = e.touches[0].clientY; // 터치 시작 위치 저장
  };

  const handleTouchMove = (e) => {
    e.preventDefault(); // preventDefault를 호출하여 스크롤 방지
    const deltaY = startY - e.touches[0].clientY; // 터치 이동 거리
    // deltaY가 0보다 크면 아래로 스크롤, 작으면 위로 스크롤
    if (isScrolling) return; // 이미 스크롤 중이면 리턴
    setIsScrolling(true); // 스크롤 시작

    // 터치 방향에 따라 페이지 이동
    // if (deltaY > 10) {
    //   if (currentPage < 6) { // 6페이지까지 존재한다고 가정
    //     console.log("큼!",currentPage)
    //     scrollToPage(currentPage);
    //   }
    // } else if(deltaY < -10 ) {
    //   if (currentPage > 1) {
    //     scrollToPage(currentPage - 2); // 이전 페이지로
    //   }
    // }

    // 터치 방향에 따라 페이지 이동
    if (deltaY > 0 && currentPage < 6) {
      scrollToPage(currentPage);
    } else if (deltaY < 0 && currentPage > 1) {
      scrollToPage(currentPage - 2); // 이전 페이지로
    }

    // 1초 후에 스크롤 상태 리셋
    setTimeout(() => {
      setIsScrolling(false);
    }, 700); // 1000ms = 1초
    //마지막 리셋해주기
    startY = 0
  };


  useEffect(() => {
    const outerDiv = outerDivRef.current;
    outerDiv.addEventListener("wheel", handleWheel);
    outerDiv.addEventListener("touchstart", handleTouchStart);
    outerDiv.addEventListener("touchmove", handleTouchMove);

    return () => {
      outerDiv.removeEventListener("wheel", handleWheel);
      outerDiv.removeEventListener("touchstart", handleTouchStart);
      outerDiv.removeEventListener("touchmove", handleTouchMove);
    };
  }, [currentPage, isScrolling, pageHeight, outerDivRef]); // isScrolling 추가

  const onClickDotEvent = (e) => {
    scrollToPage(e - 1); // 페이지 인덱스가 0부터 시작하므로 -1
  };


  const MAIN_POPUPS = [
  {
    popupId: "sw-award-2025",
    imageSrc: "images/shared image (2).jpeg",
    imageAlt: "제5회 공공부문 SW AWARD 수상 안내",
    title: "제5회 공공부문 SW AWARD",
    description: `
수상부문 : 클라우드 SaaS

회사명 : ㈜이케이시스

대표자 : 김경열

제품명 : 교통약자 이동지원 클라우드 SaaS 관제서비스

2025.05.16
    `,
  },
  {
    popupId: "privacy-education-2026",
    imageSrc: "images/privacy-education-2026.png",
    imageAlt: "2026 중소·영세 기업 대상 개인정보 보호 교육 안내",
    imageHref: "https://edu.privacy.go.kr/user/index/mainView.do",
    imageOnly: true,
    // 한국시간 2026년 11월 30일까지 게시 (12월 1일 0시부터 숨김).
    expiresAt: "2026-12-01T00:00:00+09:00",
    // 이미지와 텍스트를 함께 쓰기로 결정하면 imageOnly를 false로 바꾸고
    // 아래 title, description, href, linkLabel의 주석을 해제한다.
    /*
    title: "2026 중소·영세 기업 대상 개인정보 보호 교육",
    description: `
교육 일시: 2026.9.1. ~ 2026.11.30 중 교육 희망일자 (선착순 마감)

교육 대상: 중소기업, 영세기업 등 (※ 1회 당 교육 수강생 최소 50명 이상)

교육 시간: 2시간 이내

운영 방법: 교육 신청 기관 방문 또는 온라인 실시간 화상 교육 (※ 운영방법은 신청기관과 협의 후 확정)

교육 내용
① 개인정보 보호법 주요 내용
② 개인정보 안전성 확보조치
③ 기업 맞춤형 Q&A

신청 방법: 개인정보배움터 오프라인 교육 신청 페이지 접수
※ 신청경로: 개인정보배움터 (로그인 필수) > 개인정보 처리자 > 오프라인 교육 > 중소·영세 사업자
※ 개인정보배움터 링크: https://edu.privacy.go.kr/user/index/mainView.do

문의처: 개인정보 보호 교육 운영사무국(02-587-3073, edu_privacy@sangsangn.co.kr)
    `,
    href: "https://edu.privacy.go.kr/user/index/mainView.do",
    linkLabel: "교육 신청 안내",
    */
  },
  /*
  {
    popupId: "notice-2025-02",
    imageSrc: "images/popup_notice_02.jpg",
    imageAlt: "두 번째 공지 이미지",
    title: "새로운 공지사항",
    description: "팝업 내용을 입력하세요.",
  },
  */
];

  return (
    <>
      <div className="main_popups">
        {MAIN_POPUPS.map((popup, index) => (
          <ImagePopup
            key={popup.popupId}
            {...popup}
            index={index}
          />
        ))}
      </div>

      <div className='outer_div' ref={outerDivRef}>
        <Dots currentPage={currentPage} onClickDotEvent={onClickDotEvent} />
        <div className='inner_div main'>
            <MainImage className={`blur_${currentPage == 1 ? "off" : "on" }`} />
        </div>
        <div className='inner_div'>
          <div className='front_second_main_img'>
            <div className='second_sub'>
              eKsys is Leading Company of New GIS Software Products
            </div>
            <div className='second_title'>
              창조적인 사고, 혁신적인 개발, 합리적인 기술을 제공 경영이념을 바탕으로
              IT Business 기업으로서,<br />
              방향성과 방법론에 대한 연구를 통해 그 기술력을 인정받고 있습니다.
            </div>
          </div>
        </div>
        <div className='inner_div main'>
          <div className='front_wrap_new'>
            <div className='wrap_img_con'>
              <img src='images/eksys_Iphone.png' className='front_main_img fit' alt='이케이시스 설명 이미지' />
            </div>
            
            <div className='front_main_sub intro'>
              <span className=''>
                <span className='sky_blue_span'>GIS Engine 개발</span>
                <span className='deep_blue_span'>Mobile 네비게이션</span>
                <span className='green_span'>LBS 관련 서비스</span>
                분야에 끊임 없는 기술개발로 성장해 가고 있습니다.
              </span>
            </div>
          </div>

        </div>
        <div className='inner_div dynamic'>
          <ProductMenuNew />      
        </div>
        <div className='inner_div partner'>
          <PartnerNew />
        </div>
         <div className='inner_div last'>
          <div className='contact_div_new' >
            <div className='second_sub mo' >
              제품에 대한 문의를 주세요.
              <br />
              보다 빠른 답변을 위해 노력하겠습니다.
            </div>
            <Link to={URL.CONTACT} className='contact_btn'>CONTACT US</Link>
          </div>
          
          
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Main2;
// import Dots from 'components/Dots';
// import Footer from 'components/Footer';
// import ImagePopup from 'components/ImagePopup';
// import MainImage from 'components/MainImage';
// import PartnerNew from 'components/PartnerNew';
// import ProductMenuNew from 'components/ProductMenuNew';
// import URL from 'constants/url';

// import useFullPageScroll from 'hooks/useFullPageScroll';
// import { Link } from 'react-router-dom';

// const PAGE_COUNT = 6;

// const MAIN_POPUPS = [
//   {
//     popupId: 'sw-award-2025',
//     imageSrc: 'images/shared image (2).jpeg',
//     imageAlt: '제5회 공공부문 SW AWARD 수상 안내',
//     title: '제5회 공공부문 SW AWARD',
//     description: `
// 수상부문 : 클라우드 SaaS

// 회사명 : ㈜이케이시스

// 대표자 : 김경열

// 제품명 : 교통약자 이동지원 클라우드 SaaS 관제서비스

// 2025.05.16
//     `,
//   },
// ];

// function Main2() {
//   const {
//     outerDivRef,
//     currentPage,
//     scrollToPage,
//   } = useFullPageScroll({
//     pageCount: PAGE_COUNT,
//     lockTime: 850,
//     wheelThreshold: 12,
//     swipeThreshold: 45,
//   });

//   const onClickDotEvent = (pageNumber) => {
//     scrollToPage(pageNumber);
//   };

//   return (
//     <>
//       {MAIN_POPUPS.map((popup, index) => (
//         <ImagePopup
//           key={popup.popupId}
//           {...popup}
//           index={index}
//         />
//       ))}

//       <div className="outer_div" ref={outerDivRef}>
//         <Dots
//           currentPage={currentPage}
//           pageCount={PAGE_COUNT}
//           onClickDotEvent={onClickDotEvent}
//         />

//         <div className="inner_div main">
//           <MainImage className={`blur_${currentPage === 1 ? 'off' : 'on'}`} />
//         </div>

//         <div className="inner_div">
//           <div className="front_second_main_img">
//             <div className="second_sub">
//               eKsys is Leading Company of New GIS Software Products
//             </div>
//             <div className="second_title">
//               창조적인 사고, 혁신적인 개발, 합리적인 기술을 제공 경영이념을 바탕으로
//               IT Business 기업으로서,<br />
//               방향성과 방법론에 대한 연구를 통해 그 기술력을 인정받고 있습니다.
//             </div>
//           </div>
//         </div>

//         <div className="inner_div main">
//           <div className="front_wrap_new">
//             <div className="wrap_img_con">
//               <img
//                 src="images/eksys_Iphone.png"
//                 className="front_main_img fit"
//                 alt="이케이시스 설명 이미지"
//               />
//             </div>

//             <div className="front_main_sub intro">
//               <span>
//                 <span className="sky_blue_span">GIS Engine 개발</span>
//                 <span className="deep_blue_span">Mobile 네비게이션</span>
//                 <span className="green_span">LBS 관련 서비스</span>
//                 분야에 끊임 없는 기술개발로 성장해 가고 있습니다.
//               </span>
//             </div>
//           </div>
//         </div>

//         <div className="inner_div dynamic">
//           <ProductMenuNew />
//         </div>

//         <div className="inner_div partner">
//           <PartnerNew />
//         </div>

//         <div className="inner_div last">
//           <div className="contact_div_new">
//             <div className="second_sub mo">
//               제품에 대한 문의를 주세요.
//               <br />
//               보다 빠른 답변을 위해 노력하겠습니다.
//             </div>
//             <Link to={URL.CONTACT} className="contact_btn">
//               CONTACT US
//             </Link>
//           </div>

//           <Footer />
//         </div>
//       </div>
//     </>
//   );
// }

// export default Main2;
